import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TaskInfo } from '../../../api';
import LabelAndTextBox from '../../molecules/labelandtextbox/LabelAndTextBox';
import './TaskInfo.css';

interface TaskInfoProp {
    taskInfo: TaskInfo;
}

const TaskInfoSection: React.FC<TaskInfoProp> = (props) => {

    return (
        <div className='align-items-center tablecolor'>
            <Row>
                <Col xs={12}>
                    <LabelAndTextBox title='Ort och Datum' remark={props.taskInfo?.cityAndDate}
                        onChange={(value) => {
                            props.taskInfo.cityAndDate = value;
                        }} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='Underskrift' remark={props.taskInfo?.signature}
                        onChange={(value) => {
                            props.taskInfo.signature = value;
                        }} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='Telefonnummer' remark={props.taskInfo.phoneNumber}
                        onChange={(value) => {
                            props.taskInfo.phoneNumber = value;
                        }} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='Namnförtydligande' remark={props.taskInfo.nameClarification}
                        onChange={(value) => {
                            props.taskInfo.nameClarification = value;
                        }} />
                </Col>
                <Col xs={12}>
                    <LabelAndTextBox title='Företag/befattning' remark={props.taskInfo?.stbCompany}
                        onChange={(value) => {
                            props.taskInfo.stbCompany = value;
                        }} />
                </Col>
            </Row>
        </div>
    );
};

export default TaskInfoSection;